export default "__VITE_ASSET__C3QSic6y__"